import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { NETWORKS } from '../../constants/constants'
import HeroLookup from '../HeroLookup'
import SearchFormSimple from '../SearchFormSimple'
import SortFilter from '../SortFilter/SortFilter'
import Wizard from './Wizard'
import './MatchSearch.css'

const TabPanel = ({ active, children, id }) => {
    return id === active ? <>{children}</> : null
}

const MatchSearch = ({
    filters,
    isLoading,
    isWallet,
    onFilterChange,
    onSearch,
    onSelectedHeroChange,
    onSortByChange,
    onViewToggled,
}) => {
    const [searchCriteria, setSearchCriteria] = useState({
        auctionType: 'assisting',
        mainHero: null,
        network: NETWORKS.dfkchain.id,
        searchWallets: [],
        summonClass: '',
        summonSubclass: 'all',
        summonProfession: 'all',
    })
    const [tab, setTab] = useState('1')

    // Updates the selected Hero
    const handleHeroChange = async ({ target }) => {
        // Set a default for the class to summon based on the selected hero
        const hero = target.value
        handleSearchCriteriaChange(target)

        // Update filters based on selected hero
        hero.mutationClass &&
            handleSearchCriteriaChange([
                { key: 'summonClass', value: hero.mutationClass },
                { key: 'network', value: hero.network },
            ])
        onFilterChange({ key: 'maxGen', value: hero.generation })

        onSelectedHeroChange(hero)
        setTab('2')
    }

    // Tell calling component to search
    const handleSearch = () => {
        onSearch(searchCriteria)
        setTab('3')
    }

    // Updates search criteria
    const handleSearchCriteriaChange = input => {
        // Handle multiple items
        if (Array.isArray(input)) {
            setSearchCriteria(prevSearchCriteria =>
                input.reduce(
                    (prevItem, currItem) => ({ ...prevItem, [currItem.key]: currItem.value }),
                    prevSearchCriteria
                )
            )
        } else {
            const { key, value } = input
            setSearchCriteria(prevSearchCriteria => ({ ...prevSearchCriteria, [key]: value }))
        }
    }

    // Change the selected tab
    const handleTabChange = (event, value) => {
        setTab(value)
    }

    return (
        <div className="summoning-match-search">
            <Wizard tab={tab} onTabSelected={handleTabChange} />
            <div className="content">
                <TabPanel active={tab} id="1">
                    <HeroLookup name="mainHero" onHeroSelected={handleHeroChange} />
                </TabPanel>
                <TabPanel active={tab} id="2">
                    <SearchFormSimple
                        isSearchEnabled={!isLoading && !!searchCriteria.summonClass}
                        onSearch={handleSearch}
                        onSearchCriteriaChange={handleSearchCriteriaChange}
                        values={searchCriteria}
                    />
                </TabPanel>
                <TabPanel active={tab} id="3">
                    <SortFilter
                        filters={filters}
                        isWallet={isWallet}
                        onFilterChange={onFilterChange}
                        onSortByChange={onSortByChange}
                        onViewToggled={onViewToggled}
                    />
                </TabPanel>
            </div>
        </div>
    )
}

MatchSearch.propTypes = {
    filters: PropTypes.object,
    isLoading: PropTypes.bool,
    isWallet: PropTypes.bool.isRequired,
    onError: PropTypes.func,
    onFilterChange: PropTypes.func,
    onSelectedHeroChange: PropTypes.func,
    onSearch: PropTypes.func,
    onSortByChange: PropTypes.func,
    onViewToggled: PropTypes.func,
}

MatchSearch.defaultProps = {
    filters: {},
    onError: () => {},
    onFilterChange: () => {},
    onSelectedHeroChange: () => {},
    onSearch: () => {},
    onSortByChange: () => {},
    onViewToggled: () => {},
}

export default MatchSearch
